module.exports = __webpack_public_path__ + "static/SM6-24b505deddf919627f1c5a3fbf8f9b5f.png";